import React from 'react'
import s from './MediaEmbed.module.scss'

export const SpotifyVideoEmbed = ({
    title,
    videoId,
}: {
    title: string
    videoId: string
}): JSX.Element => {
    return (
        <div className={s.videoEmbed}>
            <iframe
                title={title}
                src={`https://open.spotify.com/embed/episode/${videoId}/video`}
                frameBorder={0}
                allowFullScreen
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
            />
        </div>
    )
}
